export default "__VITE_ASSET__D$Fg4Xg$__"